import { render, staticRenderFns } from "./d-card4.vue?vue&type=template&id=3a890e92&scoped=true"
import script from "./d-card4.vue?vue&type=script&lang=js"
export * from "./d-card4.vue?vue&type=script&lang=js"
import style0 from "./d-card4.vue?vue&type=style&index=0&id=3a890e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a890e92",
  null
  
)

export default component.exports